import React from 'react';
import { BuildingLibraryIcon } from '@heroicons/react/24/outline';
import FinButton from './fin-button';

// Where the money lands, on the page a restaurant opens to ask exactly that
// (spec 2026-09-21 §4.4): the mock's one-line strip — tile, label, bank on
// one line, Manage on the right.
//
// Changing it belongs to Stripe's own account form, so Manage hands over
// to the host — Overview sends it to Business Details' Payout details card
// (owner, 2026-09-23) — rather than opening anything here, and is not drawn
// at all for a viewer the Payouts route refuses. Draws nothing when Stripe
// named no destination: an empty bank card is a worry, not information.
// Never "•••• null": each fragment only with its value.
const ConnectPayoutAccount = ({ balance, canManagePayouts = false, onManage }) => {
  if (!balance?.bankName) return null;

  const tail = [
    balance.bankLast4 ? `· •••• ${balance.bankLast4}` : null,
    balance.bankCurrency ? `· ${balance.bankCurrency.toUpperCase()}` : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <section className="flex items-center gap-3.5 rounded-xl border border-fin-border bg-fin-surface px-[22px] py-4">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-fin-border bg-fin-recess">
        <BuildingLibraryIcon className="h-4 w-4 text-fin-muted" aria-hidden="true" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-[12.5px] font-medium text-fin-muted">Payout account</p>
        <p className="mt-0.5 truncate text-[14px]">
          <span className="font-semibold text-fin-ink">{balance.bankName}</span>
          {tail ? <span className="font-medium text-fin-muted">{` ${tail}`}</span> : null}
        </p>
      </div>
      {canManagePayouts ? <FinButton onClick={onManage}>Manage</FinButton> : null}
    </section>
  );
};

export default ConnectPayoutAccount;
